import Vue from 'vue';
import type VueRouter from 'vue-router';

export default (): VueRouter => {
	return Vue.prototype.$nuxt.$router;
};
